var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('button', {
    staticClass: "s-btn s-btn-xs",
    class: "".concat(_vm.variant),
    attrs: {
      "type": "button",
      "disabled": _vm.disabled || _vm.isLoading
    },
    on: {
      "click": _vm.click
    }
  }, [_vm.isLoading ? _c('b-spinner', {
    staticClass: "s-spinner",
    staticStyle: {
      "border-width": "1px",
      "height": "1rem",
      "width": "1rem"
    },
    attrs: {
      "size": "sm"
    }
  }) : _vm._t("default")], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }